import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core';

interface Props {
  customerId: number;
  isDark: boolean;
  link?: string;
}

const useStyles = makeStyles((theme) => ({
  icon: {
    width: '48px',
    height: 'auto',
    padding: `${theme.spacing(0.25)}px`,
    [theme.breakpoints.down('sm')]: {
      width: '36px',
    },
  },
}));

const SiteIcon = (props: Props) => {
  const [image, setImage] = useState('');
  const { customerId, isDark } = props;
  const classes = useStyles();

  const updateIcon = (id: number) => {
    const newIcon = `/logos/icon${id}.png`;
    const newIconDark = `/logos/icon${id}-dark.png`;

    setImage(isDark ? newIconDark : newIcon);
  };

  useEffect(() => {
    updateIcon(customerId);
  }, [customerId]);

  const renderImage = () => {
    return (
      <img alt="Company Icon" className={classes.icon} src={image} onError={() => updateIcon(0)} />
    );
  };

  return (
    <div style={{ display: 'flex' }}>
      {props.link ? <Link to={props.link}>{renderImage()}</Link> : renderImage()}
    </div>
  );
};

SiteIcon.defaultProps = { isDark: false };

export default SiteIcon;
